import PainPoint from "./components/painPoint"
import Product from "./components/product"
import Teacher from "./components/teacher"
import Teaching from "./components/teaching"
import Reason from "./components/reason"
import College from "./components/college"
import Information from "./components/information"
import FriendLinks from "./components/friendLinks"

function Index() {
  return (
    <div className="home">
      <PainPoint />
      <Product />
      <Teacher />
      <Teaching />
      <Reason />
      <College />
      <Information />
      <FriendLinks />
    </div>
  )
}

export default Index
